import React from 'react';

// Import all preview components
import BookPromoPreview from '../../BookPromo/BookPromoPreview';
import ThreeStepsPreview from '../../ThreeSteps/ThreeStepsPreview';
import TestimonialsPreview from '../../Testimonials/TestimonialsPreview';
import AssistanceLevelsPreview from '../../AssistanceLevels/AssistanceLevelsPreview';
import DYPAdvantagesPreview from '../../DYPAdvantages/DYPAdvantagesPreview';
import DYPLicensedUserPreview from '../../DYPLicensedUser/DYPLicensedUserPreview';
import DYPToolPreview from '../../DYPTool/DYPToolPreview';
import CharterSectionPreview from '../../CharterSection/CharterSectionPreview';
import CharterTypesPreview from '../../CharterTypes/CharterTypesPreview';
import PartnersBenefitsPreview from '../../PartnerBenefits/PartnersBenefitsPreview';
import PCProcessPreview from '../../PCProcess/PCProcessPreview';
import SliversPreview from '../../SliversOfAmbiguity/SliversPreview';
import Hero from '../../Hero/Hero';

// Create the component mapping with consistent IDs
export const blockPreviewComponents = {
  bookPromo: BookPromoPreview,
  threeSteps: ThreeStepsPreview,
  testimonials: TestimonialsPreview,
  assistanceLevels: AssistanceLevelsPreview,
  dypAdvantages: DYPAdvantagesPreview,
  dypLicensedUser: DYPLicensedUserPreview,
  dypTool: DYPToolPreview,
  charterSection: CharterSectionPreview,
  charterTypes: CharterTypesPreview,
  partnersBenefits: PartnersBenefitsPreview,
  pcProcess: PCProcessPreview,
  slivers: SliversPreview,
  hero: Hero,
  // Add alternative mappings for consistency
  charter: CharterSectionPreview,
  partners: PartnersBenefitsPreview,
  sliversOfAmbiguity: SliversPreview
};

// Fallback component for missing previews
const FallbackPreview = ({ block }) => (
  <div style={{ 
    padding: '40px', 
    backgroundColor: '#f5f5f5', 
    textAlign: 'center',
    borderRadius: '8px',
    border: '2px dashed #ccc'
  }}>
    <h3 style={{ color: '#666', marginBottom: '10px' }}>{block.name}</h3>
    <p style={{ color: '#999' }}>Preview not available</p>
  </div>
);

// Unified preview renderer with memoization
export const PreviewRenderer = React.memo(({ block, config }) => {
  const PreviewComponent = blockPreviewComponents[block.id];
  
  if (!PreviewComponent) {
    return <FallbackPreview block={block} />;
  }
  
  return <PreviewComponent config={config} />;
}, (prevProps, nextProps) => {
  // Custom comparison for performance
  return (
    prevProps.block.id === nextProps.block.id &&
    JSON.stringify(prevProps.config) === JSON.stringify(nextProps.config)
  );
});

PreviewRenderer.displayName = 'PreviewRenderer';